
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages/purewow",
      function () {
        return require("private-next-pages/packages/purewow.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages/purewow"])
      });
    }
  